import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { FileInfoController } from '@commoncore/controller/FileInfoController';
import { FileInfoImplementation } from '@commoncore/implementation/FileInfoImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
@Component({
  standalone:true,
  selector: 'lib-file-info-activity',
  templateUrl: './file-info-activity.component.html',
  styleUrls: ['./file-info-activity.component.scss'],
  imports:[CommonModule]
})
export class FileInfoActivityComponent implements OnInit {
  public universalService:any;
  fileInfoController: any;
  fileInfoImpl: any;
  textToAppend:any = "ago"
  isActivityLoaded:boolean = false;
  fileFormatIcon: any;
  customMetadataService: any;
  public constructor(public globalService:GlobalService) {
    this.fileInfoImpl = new FileInfoImplementation(globalService);
    this.universalService = globalService.getUniversalServiceRef();
    this.customMetadataService = globalService.getCustomMetadataServiceRef();
  }

  ngOnInit(): void {
    this.fileInfoController = FileInfoController.getInstance(this.globalService);
    this.fileInfoController.setEnvObjects(this.globalService);
    this.setInfoActivityHeight();
    this.getObjectActivity("");
  }

  setInfoActivityHeight(){
    // let header_ele = document.getElementById('desk-info-header');
    // let img_ele = document.getElementById('desk-info-img-wrapper');
    // let info_cont = (document.querySelector('.file-info-scrollable')) as any;
    // let height;
    // if(this.universalService.isMobileDevice) {
    //   let tabContent = document.querySelector('.slidemenu-file-info') as any
    //   height = (window.innerHeight- (header_ele.offsetHeight + tabContent.offsetHeight + 20)).toString() + 'px';
    // } else {
    //   height = (window.innerHeight- (header_ele.offsetHeight + img_ele.offsetHeight + 80)).toString() + 'px';
    // }    
    // info_cont.style.height = height

    let header_ele = document.getElementById('desk-info-header');
    let img_ele = document.getElementById('desk-info-img-wrapper');
    let info_cont = (document.querySelector('.file-info-scrollable')) as any;
    let nav_height = document.querySelector('.slidemenu-file-info') as any;
    let height;
    if(this.universalService.isMobileDevice) {
      height = (window.innerHeight- (header_ele.offsetHeight + nav_height.offsetHeight + 12)).toString() + 'px';
    } else {
      height = (window.innerHeight- (header_ele.offsetHeight + img_ele.offsetHeight + (nav_height ? nav_height.offsetHeight + 20 : 0))).toString() + 'px';
    }    
    info_cont.style.height = height
  }

  async getObjectActivity(nextLink) {
    var self = this;
    this.fileInfoImpl.isDataOfScrollLoaded = false;
    this.fileInfoImpl.toggleSmallLoader(true);
    var activityData = await this.fileInfoController.getActivityInFileInfo(this.universalService.selectedFile, nextLink);
    if((activityData != undefined ||  activityData != null) && activityData["auditTrail"]) {
      this.fileInfoImpl.currentTimeToUse = new Date().getTime();
      activityData["auditTrail"].map(item=>{
        item["formatClass"] = self.getFileFormatIcon(item);
      });
      
      Array.prototype.push.apply(this.fileInfoImpl.fileInfoActivityData, activityData["auditTrail"]);
      // If got activity of page limit 
      if(activityData.nextLink != undefined) {
        this.fileInfoImpl.isNextPageAvailable = true;
        this.fileInfoImpl.isDataOfScrollLoaded = true;
        this.fileInfoImpl.activityNextLink = activityData.nextLink;
      } else {
        this.fileInfoImpl.isNextPageAvailable = false;
        this.fileInfoImpl.isDataOfScrollLoaded = true;
        this.fileInfoImpl.activityNextLink = "";
      }
    }
    this.fileInfoImpl.toggleSmallLoader(false);
    this.isActivityLoaded = true;
  }

  attachKeysToPhoto(photoPath) {
    if(photoPath){
      let type = this.universalService.checkIfImgTypeParamIsRequired("");
      photoPath = photoPath.includes('?') ? photoPath + '&': photoPath + '?';
      return 'url('+photoPath + 'size=a' + '&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]['X-Api-Key'] + type +')';
    }
  }

  onScrollDownActivity(){

    var docheight = document.querySelector('.activity-tab-content').scrollHeight;
    var toppos =  $(".activityScrollableContainer").scrollTop();
    if ((toppos + $(".activityScrollableContainer").innerHeight()) >= (0.95 * docheight) && 
      this.fileInfoImpl.isDataOfScrollLoaded == true &&
      this.fileInfoImpl.isNextPageAvailable == true && (this.fileInfoImpl.activityNextLink && this.fileInfoImpl.activityNextLink != "" )) {
      //call http and append data
      this.getObjectActivity(this.fileInfoImpl.activityNextLink);
    }
  }

  getFileFormatIcon(object) {
    var fileFormat = this.customMetadataService.setFormatType([object]);
    fileFormat = fileFormat[0]["format"];
    var format = fileFormat.substring(0,1).toUpperCase() + fileFormat.substring(1);
    this.fileFormatIcon = this.universalService.FileInfo["Default_Format_Icon"][format];
    return this.fileFormatIcon.className;
  }

}
